import ApplicationController from "./application_controller";

//import TomSelect from 'tom-select/dist/esm/tom-select'
import TomSelect from 'tom-select'
import 'tom-select/dist/css/tom-select.css'
import '../stylesheets/tom-select.scss'


export default class extends ApplicationController {
    static targets = [ "input", "activeFilter", "inactiveFilter", "allFilter" ]


    connect() {
        this.initializeTomSelect();
        this.activeOnly = false;
        this.inactiveOnly = false;
    }

    disconnect() {
        if (this.tomselect) {
            this.tomselect.destroy();
        }
    }

    filterActive(event) {
        event.preventDefault();
        this.activeOnly = true;
        this.inactiveOnly = false;
        this.updateFilterButtons();
        if (this.tomselect) {
            this.tomselect.clear();
            this.tomselect.clearOptions();
        }
    }

    filterInactive(event) {
        event.preventDefault();
        this.activeOnly = false;
        this.inactiveOnly = true;
        this.updateFilterButtons();
        if (this.tomselect) {
            this.tomselect.clear();
            this.tomselect.clearOptions();
        }
    }

    filterAll(event) {
        event.preventDefault();
        this.activeOnly = false;
        this.inactiveOnly = false;
        this.updateFilterButtons();
        if (this.tomselect) {
            this.tomselect.clear();
            this.tomselect.clearOptions();
        }
    }

    updateFilterButtons() {
        if (this.hasActiveFilterTarget) {
            this.activeFilterTarget.classList.toggle('btn-primary', this.activeOnly);
            this.activeFilterTarget.classList.toggle('btn-default', !this.activeOnly);
        }
        if (this.hasInactiveFilterTarget) {
            this.inactiveFilterTarget.classList.toggle('btn-primary', this.inactiveOnly);
            this.inactiveFilterTarget.classList.toggle('btn-default', !this.inactiveOnly);
        }
        if (this.hasAllFilterTarget) {
            this.allFilterTarget.classList.toggle('btn-primary', !this.activeOnly && !this.inactiveOnly);
            this.allFilterTarget.classList.toggle('btn-default', this.activeOnly || this.inactiveOnly);
        }
    }

    initializeTomSelect() {
        const model = this.element.dataset.model;
        const isRequired = this.inputTarget.hasAttribute('required');

        // if placeholder is set, use it, otherwise use the default
        let placeholder = this.inputTarget.dataset.placeholder ? this.inputTarget.dataset.placeholder : "Suchen";
        let plugins = {};

        // Multifilter: <select multiple> -> mehrere Werte mit Entfernen-Buttons, offene Liste.
        const isMultiple = this.inputTarget.multiple;
        if (isMultiple) {
            plugins.remove_button = { title: 'Entfernen' };
        }

        let config = {
            plugins: plugins,
            // Dropdown am <body> rendern, sonst schneidet ein Vorfahr mit overflow-hidden
            // (z.B. die gerundeten Filter-Chips der Anfragen-Liste) die Trefferliste ab —
            // die Suche liefert dann Ergebnisse, klappt aber sichtbar nicht auf. Analog
            // zum plain tomselect-Controller.
            dropdownParent: 'body',
            create: false,
            valueField: 'id',
            labelField: 'text',
            searchField: ['text', 'tags'],
            maxItems: isMultiple ? null : 1,
            closeAfterSelect: isMultiple ? false : true,
            selectOnTab: true,
            placeholder: placeholder,
            required: isRequired,
            validateOnBlur: true,
            onInvalid: function() {
                this.wrapper.classList.add('ts-error');
            },
            onValid: function() {
                this.wrapper.classList.remove('ts-error');
            }
        };

        if (model === 'jobs') {
            let currentFilter = 'all'; // Standardmäßig alle Jobs anzeigen

            // Status-Filter hinzufügen
            const filterHtml = `
                <div class="flex gap-2 mb-2 px-2 py-1">
                    <button type="button" class="inline-flex items-center px-2.5 py-1.5 rounded-full text-xs font-medium bg-gray-300 text-gray-800 hover:bg-gray-200 cursor-pointer status-filter" data-status="all">
                        Alle
                    </button>
                    <button type="button" class="inline-flex items-center px-2.5 py-1.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 hover:bg-gray-200 cursor-pointer status-filter" data-status="active">
                        <span class="w-1.5 h-1.5 rounded-full bg-green-500 mr-1.5"></span>
                        Aktiv
                    </button>
                    <button type="button" class="inline-flex items-center px-2.5 py-1.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 hover:bg-gray-200 cursor-pointer status-filter" data-status="inactive">
                        <span class="w-1.5 h-1.5 rounded-full bg-gray-400 mr-1.5"></span>
                        Inaktiv
                    </button>
                </div>
            `;

            // Funktion zum Filtern der Optionen
            const filterOptions = (status, tomselect) => {
                const options = tomselect.options;
                Object.keys(options).forEach(key => {
                    const option = options[key];
                    // Entferne die Option komplett, wenn sie nicht dem Filter entspricht
                    if (status !== 'all' && ((status === 'active' && !option.active) || (status === 'inactive' && option.active))) {
                        tomselect.removeOption(key);
                    }
                });
            };

            config.render = {
                dropdown: function() {
                    return '<div class="ts-dropdown"><div class="ts-dropdown-content">' + filterHtml + '</div></div>';
                },
                option: function(data, escape) {
                    const subtext = data.subtext 
                        ? `<div class="subtext text-xs text-gray-400 truncate">${data.subtext}</div>` 
                        : '';
                    const status = data.active ? 
                        '<span class="inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"><span class="w-1.5 h-1.5 rounded-full bg-green-500 mr-1"></span>Aktiv</span>' :
                        '<span class="inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800"><span class="w-1.5 h-1.5 rounded-full bg-gray-400 mr-1"></span>Inaktiv</span>';
                    const id = data.id ? `<span class="text-xs text-gray-500">#${data.id}</span>` : '';
                    
                    // Prüfe ob bereits beworben
                    const isApplied = data.applied || false;
                    const appliedText = isApplied ? '<span class="inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800"><i class="fas fa-check mr-1"></i>Bereits beworben</span>' : '';
                    
                    // Styling für bereits beworbene Jobs
                    const optionClass = isApplied ? 'option flex flex-col opacity-60 cursor-not-allowed' : 'option flex flex-col';
                    const titleClass = isApplied ? 'title text-sm font-medium text-gray-500' : 'title text-sm font-medium';
                    
                    return `<div class="${optionClass}">
                        <div class="flex items-center justify-between">
                            <div class="${titleClass}">${escape(data.text)}</div>
                            <div class="flex items-center gap-2">
                                ${id}
                                ${status}
                                ${appliedText}
                            </div>
                        </div>
                        ${subtext}
                    </div>`;
                },
                item: function(data, escape) {
                    return '<div class="item text-sm">' + escape(data.text) + '</div>';
                },
                no_results: function(data, escape) {
                    return '<div class="no-results p-2 text-sm text-gray-600">Keine Ergebnisse für "' + escape(data.input) + '"</div>';
                }
            };

            // Event-Handler für Filter-Buttons
            config.onDropdownOpen = function(dropdown) {
                const filters = dropdown.querySelectorAll('.status-filter');
                filters.forEach(filter => {
                    filter.addEventListener('click', (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        currentFilter = e.currentTarget.dataset.status;
                        
                        // Aktiven Filter hervorheben
                        filters.forEach(f => {
                            f.classList.toggle('bg-gray-100', f.dataset.status !== currentFilter);
                            f.classList.toggle('bg-gray-300', f.dataset.status === currentFilter);
                        });

                        // Suche neu starten - lade Jobs mit dem neuen Filter und aktuellem Suchbegriff
                        const currentQuery = this.input.value || '';
                        this.clear();
                        this.clearOptions();
                        // Lade Jobs mit dem neuen Filter und aktuellem Suchbegriff
                        this.load(currentQuery, (options) => {
                            this.addOptions(options);
                        });
                        this.focus();
                    });
                });
            };

            // Modifiziere die load-Funktion für Jobs
            config.load = (query, callback) => {
                // Für Jobs: auch bei leerem Query laden (mit Filter)
                if (model === 'jobs') {
                    // Verwende den generischen Search-Endpoint mit Jobs-spezifischen Parametern
                    let url = `/backend/search?term=${encodeURIComponent(query || '')}&model=jobs`;
                    
                    // Füge active Parameter nur für Jobs hinzu, wenn nicht "alle" ausgewählt ist
                    if (currentFilter !== 'all') {
                        url += `&active=${currentFilter === 'active'}`;
                    }
                    
                    // Füge applicant_id hinzu, um bereits beworbene Jobs zu markieren
                    const applicantId = this.element.dataset.applicantId;
                    if (applicantId) {
                        url += `&applicant_id=${applicantId}`;
                    }
                    
                    fetch(url)
                        .then(response => response.json())
                        .then(json => {
                            // Backend filtert bereits, nur noch mapping und sorting
                            const mappedJson = json.map(item => ({
                                ...item,
                                status: item.active ? 'active' : 'inactive',
                                tags: item.active ? ['Aktiv'] : ['Inaktiv']
                            }));
                            
                            // Sortiere nach created_at (aktuellste zuerst)
                            const sortedJson = mappedJson.sort((a, b) => {
                                const dateA = new Date(a.created_at || 0);
                                const dateB = new Date(b.created_at || 0);
                                return dateB - dateA; // Neueste zuerst
                            });
                            
                            callback(sortedJson);
                        }).catch(() => {
                            callback();
                        });
                } else {
                    // Für andere Modelle: nur bei Query laden
                    if (!query.length) return callback();
                    let url = `/backend/search?term=${encodeURIComponent(query)}&model=${model}`;
                    
                    fetch(url)
                        .then(response => response.json())
                        .then(json => {
                            callback(json);
                        }).catch(() => {
                            callback();
                        });
                }
            };
        } else {
            config.render = {
                no_results: function (data, escape) {
                    return '<div class="no-results">Keine Ergebnisse für "' + escape(data.input) + '".</div>';
                },
                option: function(data, escape) {
                    let subtext = data.subtext ? '<br/><span class="subtext text-xs text-gray-400 truncate">' + data.subtext + '</span>' : '';
                    let label = '';
                    if (data.text && data.text.includes('@')) {
                      // Heuristik: User hat meist (Vorname Nachname <email>), Kontakt ebenso, aber wir labeln nach Modell
                      if (data.text.match(/<.+@.+>/)) {
                        if (data.text.toLowerCase().includes('kontakt') || (data.model && data.model === 'contacts')) {
                          label = '<span class="inline-block bg-green-100 text-green-800 text-xs font-semibold px-2 py-0.5 rounded mr-2">Kontakt</span>';
                        } else {
                          label = '<span class="inline-block bg-blue-100 text-blue-800 text-xs font-semibold px-2 py-0.5 rounded mr-2">User</span>';
                        }
                      }
                    }
                    return '<div class="option">' +
                        label +
                        '<span class="title text-sm">' + escape(data.text) + '</span>' +
                        subtext +
                        '</div>';
                },
                item: function(data, escape) {
                    return '<div class="item text-sm">' + escape(data.text) + '</div>';
                }
            };

            // Spezielle Konfiguration für E-Mail-Empfänger (contacts,users)
            if (model === 'contacts,users') {
                config.create = true; // Erlaube das Erstellen neuer E-Mail-Adressen
                config.createFilter = function(input) {
                    // Validiere E-Mail-Adresse
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    return emailRegex.test(input);
                };
                config.createOnBlur = true;
                config.valueField = 'text'; // Verwende den Text als Wert für E-Mail-Adressen
                config.labelField = 'text';
                
                // Erweitere die load-Funktion für E-Mail-Empfänger
                config.load = (query, callback) => {
                    if (!query.length) return callback();
                    
                    // Wenn es eine E-Mail-Adresse ist, füge sie direkt hinzu
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (emailRegex.test(query)) {
                        callback([{
                            id: query,
                            text: query,
                            subtext: 'Direkt eingegebene E-Mail-Adresse'
                        }]);
                        return;
                    }
                    
                    // Ansonsten suche nach Kontakten und Usern
                    let url = `/backend/search?term=${encodeURIComponent(query)}&model=${model}`;
                    
                    fetch(url)
                        .then(response => response.json())
                        .then(json => {
                            callback(json);
                        }).catch(() => {
                            callback();
                        });
                };
            } else {
                // Standard load-Funktion für andere Modelle
                config.load = (query, callback) => {
                    if (!query.length) return callback();
                    let url = `/backend/search?term=${encodeURIComponent(query)}&model=${model}`;
                    
                    fetch(url)
                        .then(response => response.json())
                        .then(json => {
                            callback(json);
                        }).catch(() => {
                            callback();
                        });
                };
            }
        }

        this.tomselect = new TomSelect(this.inputTarget, config);
    }

    destroyTomSelect() {
        this.tomselect.destroy();
    }
}